import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import ConciliacionCargaArchivos from "../../components/conciliacionCargaArchivos";
import Layout from "../../components/layout";

interface Props {}

class ConciliacionCargaArchivosPage extends React.Component<Props> {
  state = {
    classifications: []
  };

  componentDidMount() {}

  render() {
    return (
      <main>
        <Helmet title="Carga de archivos de conciliación" />
        <Layout>
          <ConciliacionCargaArchivos />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConciliacionCargaArchivosPage);
